(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-fish-request"] && !Shopify.designMode) return;
  try {
    
(() => {
  const fish = new URLSearchParams(window.location.search).get('requested_fish');
  const input = document.getElementById('FishRequestSpecies');
  if (fish && input && !input.value) input.value = fish.slice(0, 200);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-reef-home"] && !Shopify.designMode) return;
  try {
    
(() => {
  const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
  const initialize = () => {
    document.querySelectorAll('[data-ss-reef]').forEach(root => {
      if (root.dataset.motionReady) return;
      root.dataset.motionReady = 'true';
      const button = root.querySelector('.ss-motion-toggle');
      const hero = root.querySelector('.ss-hero-photo');
      let enabled = !preference.matches;
      try { if (sessionStorage.getItem('ss-motion') === 'off') enabled = false; } catch (_) {}
      const update = () => {
        root.classList.toggle('ss-motion-on', enabled);
        button.setAttribute('aria-pressed', String(enabled));
        button.textContent = enabled ? button.dataset.on : button.dataset.off;
        if (!enabled) { hero.style.removeProperty('--ss-x'); hero.style.removeProperty('--ss-y'); }
      };
      button.hidden = false;
      update();
      button.addEventListener('click', () => {
        enabled = !enabled;
        try { sessionStorage.setItem('ss-motion', enabled ? 'on' : 'off'); } catch (_) {}
        update();
      });
      preference.addEventListener('change', () => { enabled = !preference.matches; update(); });
      let frame = 0;
      hero.addEventListener('pointermove', event => {
        if (!enabled || event.pointerType !== 'mouse' || frame) return;
        frame = requestAnimationFrame(() => {
          const box = hero.getBoundingClientRect();
          hero.style.setProperty('--ss-x', `${((event.clientX - box.left) / box.width - .5) * 10}px`);
          hero.style.setProperty('--ss-y', `${((event.clientY - box.top) / box.height - .5) * 10}px`);
          frame = 0;
        });
      });
      hero.addEventListener('pointerleave', () => { hero.style.setProperty('--ss-x','0px'); hero.style.setProperty('--ss-y','0px'); });
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();

  } catch(e) { console.error(e); }
})();
})();
